/**
 * @fileoverview Ugc Settings View - controller for anonymize ugc settings
 *
 * @author nliang@yext.com
 */
goog.module('yext.storm.UgcSettingsView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const View = goog.require('yext.mvc.View');
const AnonymizationSettingsView = goog.require('yext.storm.AnonymizationSettingsView');
const routes = goog.require('yext.storm.routes');
const {Tooltip} = goog.require('yext.ui.components.tooltip');
/**
 * @constructor
 * @extends {View}
 */
const UgcSettingsView = function() {
  /** @type {!jQuery} */
  this.$el = $('.js-ugc-settings-field');
  this.createToolTip();

  AnonymizationSettingsView.call(this, this.$el);
};
goog.inherits(UgcSettingsView, AnonymizationSettingsView);

/** @override */
UgcSettingsView.prototype.getSubmitUrl = function() {
  return routes.AccountSettings.updateUgcSettings();
};

/** @override */
UgcSettingsView.prototype.getLabel = function(months) {
  return yext.msg(
    'Anonymize UGC after <span class=setting-value">{0}</span> months',
    months);
};

/** Render the tooltip. */
UgcSettingsView.prototype.createToolTip = function() {
  const tooltipProps = {
    unclearText: yext.msg('User-Generated Content'),
    tooltipText: yext.msg('User-generated content, which includes Review ' +
      'Invitations, Reviews, Q&A, and User Photos, will be anonymized after ' +
      'the configured period of time'),
    direction: 'bottom',
  };
  const tooltipElement = React.createElement(Tooltip, tooltipProps, null);
  ReactDOM.render(tooltipElement, document.querySelector('.js-ugc-tooltip'));
};

exports = UgcSettingsView;
